import React, { createContext, useContext, useEffect, useState } from "react";
import { api, resolveMediaSrc } from "./api";

// ── shared asset constants (mirror backend cms.py DEFAULT_CONTENT) ──────
const LOGO_MARK = "https://customer-assets.emergentagent.com/job_12dfafbc-1b50-4989-ae09-4f690ec6a290/artifacts/x0ks3hbj_logo%20only%20yellow.png";
const LOGO_FULL = "https://customer-assets.emergentagent.com/job_dev-studio-pro-4/artifacts/7hogk0ha_millpond-gatherings_logo-fullcolor-01%20%281%29.png";

const IMG = {
  heroHome: "https://images.unsplash.com/photo-1762015101892-46496da449b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  banquet: "https://images.unsplash.com/photo-1758810744028-689670b0877c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  heroSteak: "https://images.unsplash.com/photo-1702288824191-3003d32484b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  steakInterior: "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/bb5a5d61-0fca-4720-943d-b89fcac48d3f/2V1A9139.jpg",
  heroTavern: "https://images.unsplash.com/photo-1561553521-b6cddc085c5f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  riverPatio: "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/23a85740-1c70-4ab9-ae04-a9cd5f42a87e/2V1A9115-HDR+copy.jpg",
  heroVenue: "https://images.unsplash.com/photo-1758810742443-b82f48355828?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  expSteak: "https://images.unsplash.com/photo-1702288824191-3003d32484b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  expTavern: "https://images.unsplash.com/photo-1561553521-b6cddc085c5f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  expVenue: "https://images.unsplash.com/photo-1758810742443-b82f48355828?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

const GALLERY_IMAGES = [
  "https://images.unsplash.com/photo-1702288824191-3003d32484b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1561553521-b6cddc085c5f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1758810742443-b82f48355828?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1758810744028-689670b0877c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1762015101892-46496da449b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/bb5a5d61-0fca-4720-943d-b89fcac48d3f/2V1A9139.jpg",
  "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/23a85740-1c70-4ab9-ae04-a9cd5f42a87e/2V1A9115-HDR+copy.jpg",
  "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/539f9eb6-7b10-409b-9b00-37ba9d96961c/Talia+and+Cary.jpg",
  "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/d15ebcf3-6fec-4702-906f-8228a7d63851/jom+and+meg.jpg",
  "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/2804fe91-5843-41e3-8e98-dc047061aea4/sam+and+pete.jpg",
  "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/945baeb2-f8f8-4319-9aaf-07e555675adb/88483Image-113.jpg",
  "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/30e34049-7031-4f7e-b688-7973e3f70189/13794DSC07018-2.jpg",
];

const REAL_WEDDINGS = [
  { name: "Talia & Cary", image: "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/539f9eb6-7b10-409b-9b00-37ba9d96961c/Talia+and+Cary.jpg" },
  { name: "Jim & Meg", image: "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/d15ebcf3-6fec-4702-906f-8228a7d63851/jom+and+meg.jpg" },
  { name: "Sam & Pete", image: "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/2804fe91-5843-41e3-8e98-dc047061aea4/sam+and+pete.jpg" },
  { name: "Michelle & Andrew", image: "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/945baeb2-f8f8-4319-9aaf-07e555675adb/88483Image-113.jpg" },
  { name: "Meaghan & Travis", image: "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/95c5ffda-1d50-47dc-8952-9c6280829a98/meaghan+and+travis.jpg" },
  { name: "Lorena & Peter", image: "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/30e34049-7031-4f7e-b688-7973e3f70189/13794DSC07018-2.jpg" },
];

export const DEFAULTS = {
  site: {
    name: "Millpond Gatherings",
    tagline: "Steakhouse · Tavern · Event Venue",
    address: "1565 Middletown Ave, Northford, CT",
    phone: "(203) 714-4400",
    phoneRaw: "+12037144400",
    email: "hello@millpondgatherings.com",
    hours: "Tue–Sun · Lunch & Dinner",
    est: "Northford, Connecticut · Est. in a 1700s Mill",
    logoMark: LOGO_MARK,
    logoFull: LOGO_FULL,
    opentable: { steakhouse: "1234111", tavern: "1242793" },
    social: { instagram: "https://www.instagram.com/millpondgatherings", facebook: "https://www.facebook.com/millpondgatherings" },
    nav: [
      { label: "Home", to: "/" },
      { label: "Steakhouse", to: "/steakhouse" },
      { label: "Tavern", to: "/tavern" },
      { label: "Venue", to: "/venue" },
      { label: "Contact", to: "/contact" },
      { label: "Careers", to: "/careers" },
    ],
    marquee: ["Wood-fired Hearth", "Dry-Aged Steaks", "Tomahawk Thursdays", "River Patio", "Live Music", "Intimate Weddings", "Farm-Fresh Fare"],
    navReserveLabel: "Reservations",
    reservation: { eyebrow: "Reservations", title: "Where would you like to dine?", body: "Choose a venue to reserve your table directly via OpenTable." },
    footer: {
      tagline: "Your country gathering place — where heritage, hearth, and hospitality meet.",
      addressLine1: "1565 Middletown Ave,",
      addressLine2: "Northford, CT",
      hoursLabel: "Tue–Sun · Lunch & Dinner",
      copyright: "© 2026 Millpond Gatherings · Northford, CT",
      badge: "Steakhouse · Tavern · Venue",
    },
    areasServedLabel: "Proudly Serving Greater New Haven County, CT",
    areasServed: ["Northford", "North Branford", "New Haven", "North Haven", "Hamden", "Wallingford", "Branford", "East Haven", "Guilford", "Madison", "Cheshire", "Meriden", "Durham", "Middletown", "Killingworth", "Clinton"],
  },
  home: {
    heroImage: IMG.heroHome,
    visitLabel: "Visit",
    heroEyebrow: "Northford, Connecticut · Est. in a 1700s Mill",
    heroTitle: "Your country gathering place.",
    heroBody: "A steakhouse, a tavern, and a wedding venue — three soulful experiences nestled along the river, beneath one historic roof.",
    heroReserveLabel: "Reserve a Table",
    heroEventLabel: "Host an Event",
    promoPopups: [
      { day: "monday", enabled: false, eyebrow: "Mondays at The Tavern", title: "Monday Night", body: "Add your Monday special here.", photo: "", menuFile: "", buttonLabel: "View Menu", buttonUrl: "", startTime: "11:00", endTime: "21:00", autoDismissSeconds: 15 },
      { day: "tuesday", enabled: false, eyebrow: "Tuesdays at The Tavern", title: "Tuesday Special", body: "Add your Tuesday special here.", photo: "", menuFile: "", buttonLabel: "View Menu", buttonUrl: "", startTime: "11:00", endTime: "21:00", autoDismissSeconds: 15 },
      { day: "wednesday", enabled: false, eyebrow: "Wednesdays at The Tavern", title: "Wednesday Special", body: "Add your Wednesday special here.", photo: "", menuFile: "", buttonLabel: "View Menu", buttonUrl: "", startTime: "11:00", endTime: "21:00", autoDismissSeconds: 15 },
      { day: "thursday", enabled: false, eyebrow: "Thursdays at The Tavern", title: "Tomahawk Thursday", body: "Add your Thursday special here.", photo: "", menuFile: "", buttonLabel: "View Menu", buttonUrl: "", startTime: "11:00", endTime: "21:00", autoDismissSeconds: 15 },
      { day: "friday", enabled: false, eyebrow: "Fridays at The Tavern", title: "Friday Night", body: "Add your Friday special here.", photo: "", menuFile: "", buttonLabel: "View Menu", buttonUrl: "", startTime: "11:00", endTime: "22:00", autoDismissSeconds: 15 },
      { day: "saturday", enabled: false, eyebrow: "Saturdays at The Tavern", title: "Saturday Night", body: "Add your Saturday special here.", photo: "", menuFile: "", buttonLabel: "View Menu", buttonUrl: "", startTime: "11:00", endTime: "22:00", autoDismissSeconds: 15 },
      { day: "sunday", enabled: true, eyebrow: "Sundays at The Tavern", title: "Sunday Brunch", body: "Join us in The Tavern every Sunday for brunch, 11:30 AM to 3:00 PM. House classics, bottomless mimosas, and a view of the river.", photo: "https://images.unsplash.com/photo-1670710029405-ad968b51b6dc?crop=entropy&cs=srgb&fm=jpg&q=85", menuFile: "", buttonLabel: "View Brunch Menu", buttonUrl: "", startTime: "10:00", endTime: "15:00", autoDismissSeconds: 15 },
    ],
    experiencesEyebrow: "Three Experiences",
    experiencesTitle: "One historic mill, three ways to gather.",
    experiencesBody: "Whether you're savoring a 40-day aged Tomahawk by the open fire, raising a glass on the river patio, or dancing in our candlelit barn — every visit to Millpond is rooted in craftsmanship, comfort, and genuine New England care.",
    experiences: [
      { id: "steakhouse", eyebrow: "Signature Dining", title: "Steakhouse", desc: "Wood-fired hearth & dry-aged cuts.", image: IMG.expSteak, to: "/steakhouse" },
      { id: "tavern", eyebrow: "Cozy & Lively", title: "Tavern", desc: "Historic 1700s tavern, river patio.", image: IMG.expTavern, to: "/tavern" },
      { id: "venue", eyebrow: "Weddings & Events", title: "Venue", desc: "One wedding at a time.", image: IMG.expVenue, to: "/venue" },
    ],
    heritageEyebrow: "Our Heritage",
    heritageTitle: "Set within a 1700s mill, overlooking the river.",
    heritageBody1: "Original beams. A working hearth. An open floor plan that breathes. Millpond began as a gathering place for the community of Northford — and three centuries later, that's still exactly what it is.",
    heritageBody2: "Chef T leads our kitchen with farm-fresh sourcing and an unwavering commitment to flavor. The result is food that feels like home — only a little more elegant.",
    heritageCtaLabel: "Plan Your Visit",
    heritageImage: IMG.banquet,
    weeklyEyebrow: "The Weekly Rhythm",
    weeklyTitle: "A reason to return every night.",
    weekly: [
      { day: "Tuesday", title: "Taco Tuesday", desc: "Bold flavors, easygoing energy in the Tavern." },
      { day: "Wednesday", title: "Wine Wednesday", desc: "Half-priced bottles from our curated cellar." },
      { day: "Thursday", title: "Tomahawk Thursday", desc: "40-day aged 40 oz Tomahawk · live music · prime rib." },
      { day: "Friday", title: "Hearth Night", desc: "Wood-fired specials by Chef T at the Steakhouse." },
      { day: "Saturday", title: "River Patio", desc: "Sunset cocktails, weather permitting." },
      { day: "Sunday", title: "Sunday Supper", desc: "Family-style three-course menu." },
    ],
    ctaTitle: "Pull up a chair — we kept one for you.",
    ctaReserveLabel: "Reserve a Table",
    ctaEventLabel: "Inquire About Events",
  },
  steakhouse: {
    heroImage: IMG.heroSteak,
    heroEyebrow: "Signature Dining",
    heroTitle: "The Steakhouse.",
    expEyebrow: "The Experience",
    expTitle: "Anchored by the wood-fired hearth.",
    expBody1: "The Steakhouse is the signature dining experience at Millpond — a refined yet welcoming space where craftsmanship, tradition, and New England hospitality come together. Our menu features expertly aged steaks, including a selection of dry-aged cuts that showcase deep, concentrated flavor and exceptional tenderness.",
    expBody2: "Each dish is prepared with an attention to detail that honors the heritage of the building and the craft behind every ingredient.",
    menuLabel: "View the Menu →",
    menus: [
      { label: "Dinner", fileUrl: "" },
      { label: "Brunch", fileUrl: "" },
      { label: "Dessert", fileUrl: "" },
      { label: "Weekly Special", fileUrl: "" },
    ],
    interiorImage: IMG.steakInterior,
    logoSubtitle: "A wood-fired hearth, dry-aged cuts, and timeless New England hospitality — pull up a chair.",
    tomahawkEyebrow: "Thursday Tradition",
    tomahawkTitle: "Tomahawk Thursday.",
    tomahawkBody: "A 40-day aged, 40 oz Tomahawk Steak — served with appetizers, sides, desserts, and all the ceremony this show-stopping cut deserves.",
    tomahawkFeatures: ["40 days dry-aged", "40 oz prime cut", "Tableside carving", "Curated wine pairings"],
    tomahawkMenuLabel: "View the Menu →",
    tomahawkMenus: [{ label: "Tomahawk Menu", fileUrl: "" }],
    bookEyebrow: "Book Direct",
    bookTitle: "Reserve a table at The Steakhouse.",
    bookBody: "Real-time availability powered by OpenTable.",
    opentableRid: "1234111",
  },
  tavern: {
    heroImage: IMG.heroTavern,
    heroEyebrow: "Cozy & Lively",
    heroTitle: "The Tavern.",
    vibeEyebrow: "The Vibe",
    vibeTitle: "Old-world charm meets a modern, welcoming energy.",
    vibeBody1: "The Tavern is the cozy heart of Millpond — set within the original 1700s structure, it blends history with elevated comfort food, craft cocktails, and genuine hospitality.",
    vibeBody2: "When the weather's right, our patio overlooking the river becomes the perfect spot to relax, dine, and take in the view.",
    menuLabel: "View the Menu →",
    menus: [{ label: "Dinner", fileUrl: "" }],
    specialsEyebrow: "Weekly Specials",
    specialsTitle: "A new reason every night.",
    specials: [
      { day: "Daily", title: "Happy Hour", desc: "Drinks specials & tavern bites at the bar.", image: "", fileUrl: "" },
      { day: "Tuesday", title: "Taco Tuesday", desc: "Bold flavors, fun & easygoing vibe.", image: "", fileUrl: "" },
      { day: "Thursday", title: "Prime Rib Night", desc: "Slow-roasted, carved to order.", image: "", fileUrl: "" },
      { day: "Thursday", title: "Live Music", desc: "Local artists, warm soundtracks all evening.", image: "", fileUrl: "" },
    ],
    logoSubtitle: "The cozy heart of Millpond — old-world charm, craft cocktails, and a river breeze.",
    patioImage: IMG.riverPatio,
    patioEyebrow: "Outdoors",
    patioTitle: "A patio along the river.",
    patioBody: "Open seasonally — the very best seat for a glass of wine, the breeze, and the sound of moving water.",
    bookEyebrow: "Book Direct",
    bookTitle: "Reserve a stool at The Tavern.",
    bookBody: "Real-time availability powered by OpenTable.",
    opentableRid: "1242793",
  },
  venue: {
    heroImage: IMG.heroVenue,
    heroEyebrow: "Weddings & Events",
    heroTitle: "The Venue.",
    heroBody: "An elegant event space with rustic charm and farm-fresh fare — where the most memorable weddings blossom into full bloom.",
    overviewEyebrow: "Overview",
    overviewTitle: "Sophistication meets warm rustic accents.",
    overviewBody1: "Combining sophistication and warm rustic accents, the venue at Millpond Gatherings is an ideal choice for couples looking for an intimate setting. Our open-floor plan allows for maximum customization with many layout options for your event.",
    overviewQuote: "We only host one wedding at a time.",
    overviewBody2: "Surrounded by wood-textured walls and your closest loved ones, you'll feel at home in our cozy atmosphere while you dance the night away.",
    features: [
      { num: "01", title: "One wedding at a time", desc: "Privacy, exclusivity, and a day to call your own." },
      { num: "02", title: "A bridal attendant", desc: "Personal guidance throughout your entire event." },
      { num: "03", title: "Custom menu by Chef T", desc: "Farm-fresh, curated for you and your guests." },
      { num: "04", title: "Open-floor plan", desc: "Warm wood walls, chandeliers, endless layout options." },
    ],
    logoSubtitle: "Where the most memorable weddings blossom into full bloom — one celebration at a time.",
    logoCtaLabel: "Inquire Now",
    realWeddingsEyebrow: "Real Weddings",
    realWeddingsTitle: "Couples we've been honored to host.",
    realWeddings: REAL_WEDDINGS,
    inquireEyebrow: "Inquire",
    inquireTitle: "Begin the conversation.",
    inquireBody: "Tell us about your day. Our events team responds within two business days.",
  },
  gallery: {
    eyebrow: "Moments",
    title: "A look around the mill.",
    body: "From candlelit dinners to wedding parties on the river — a glimpse of life at Millpond.",
    images: GALLERY_IMAGES,
  },
  contact: {
    heroImage: "https://images.squarespace-cdn.com/content/v1/697aa64f56b680574bb377ba/23a85740-1c70-4ab9-ae04-a9cd5f42a87e/2V1A9115-HDR+copy.jpg",
    eyebrow: "Get in touch",
    title: "Visit, dine, or ask anything.",
    intro: "Whether you're planning a celebration, booking a table, or simply curious — we'd love to hear from you. Our team is here to help.",
    address: "1565 Middletown Ave, Northford, CT",
    phone: "(203) 714-4400",
    phoneRaw: "+12037144400",
    email: "hello@millpondgatherings.com",
    hours: [
      { label: "Tuesday – Thursday", value: "4:00 PM – 9:00 PM" },
      { label: "Friday – Saturday", value: "4:00 PM – 10:00 PM" },
      { label: "Sunday", value: "11:00 AM – 8:00 PM" },
      { label: "Monday", value: "Closed" },
    ],
    mapUrl: "https://www.google.com/maps?q=1565+Middletown+Ave,+Northford,+CT&output=embed",
    formTitle: "Send us a message",
    formNote: "We reply within one business day.",
    googleReviewUrl: "",
  },
  careers: {
    heroImage: IMG.steakInterior,
    heroEyebrow: "Join the Team",
    heroTitle: "Build your career at the Mill.",
    heroBody: "Become part of a historic riverside mill where craft, hospitality, and community come together. We're always looking for passionate people across the kitchen, floor, and bar.",
    introTitle: "A place to grow.",
    introBody: "Competitive pay, a tight-knit team, and a beautiful setting along the river. Whether you're behind the line, on the floor, or behind the bar — there's a seat for you at Millpond.",
    perks: [
      { title: "Flexible scheduling", desc: "Full-time and part-time roles across every department." },
      { title: "Growth & training", desc: "Learn from Chef T and a seasoned hospitality team." },
      { title: "Staff meals", desc: "Farm-fresh family meals on every shift." },
    ],
    departments: [
      { name: "Kitchen", roles: ["Cook / Line Cook", "Prep Cook", "Dishwasher", "Kitchen Helper", "Sous Chef / Head Chef"] },
      { name: "Service", roles: ["Waiter / Waitress", "Busser", "Food Runner", "Host / Hostess"] },
      { name: "Bar", roles: ["Bartender", "Barback"] },
    ],
    formTitle: "Apply now",
    formNote: "Fill in your details and attach your CV (PDF, DOC, or DOCX — up to 10MB).",
  },
};

// ── helpers ────────────────────────────────────────────────────────────
const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
const deepMerge = (base, over) => {
  if (!isObj(base) || !isObj(over)) return over === undefined ? base : over;
  const out = { ...base };
  for (const k of Object.keys(over)) {
    out[k] = isObj(base[k]) && isObj(over[k]) ? deepMerge(base[k], over[k]) : over[k];
  }
  return out;
};

// Resolve an image/media URL (handles GridFS /api/media/<id> + absolute URLs).
export const img = (url) => resolveMediaSrc(url);

const CACHE_KEY = "mp_content_cache_v1";

const buildMerged = (data) => {
  const merged = {};
  Object.keys(DEFAULTS).forEach((slug) => {
    merged[slug] = deepMerge(DEFAULTS[slug], (data && data[slug]) || {});
  });
  return merged;
};

const readCache = () => {
  try {
    const raw = typeof window !== "undefined" && window.localStorage.getItem(CACHE_KEY);
    if (raw) return buildMerged(JSON.parse(raw));
  } catch {
    /* ignore */
  }
  return null;
};

const ContentContext = createContext({ content: DEFAULTS, loaded: false, preview: null });

export const ContentProvider = ({ children }) => {
  const previewSlug = typeof window !== "undefined" ? new URLSearchParams(window.location.search).get("preview") : null;
  // Initialise from the last cached publish so the correct (admin-uploaded) media
  // shows immediately on refresh — no flash of the default image.
  const [content, setContent] = useState(() => (!previewSlug && readCache()) || DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/api/cms/public");
        try {
          window.localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        } catch {
          /* storage full / unavailable */
        }
        const merged = buildMerged(data);
        if (previewSlug && DEFAULTS[previewSlug]) {
          try {
            const { data: page } = await api.get(`/api/cms/pages/${previewSlug}`);
            merged[previewSlug] = deepMerge(DEFAULTS[previewSlug], page?.draft || {});
          } catch {
            /* not admin / no draft → keep published */
          }
        }
        if (alive) setContent(merged);
      } catch {
        /* keep cache/defaults */
      } finally {
        if (alive) setLoaded(true);
      }
    })();
    return () => {
      alive = false;
    };
  }, [previewSlug]);

  return (
    <ContentContext.Provider value={{ content, loaded, preview: previewSlug }}>
      {previewSlug && (
        <div data-testid="preview-banner" className="fixed bottom-4 left-4 z-[200] bg-[#e2b95a] text-[#942222] text-xs font-semibold tracking-wide px-4 py-2 rounded-full shadow-lg">
          Preview · draft of “{previewSlug}”
        </div>
      )}
      {children}
    </ContentContext.Provider>
  );
};

export const usePage = (slug) => {
  const { content } = useContext(ContentContext);
  return content[slug] || DEFAULTS[slug] || {};
};

export const useSite = () => usePage("site");
